export default __webpack_public_path__ + "static/media/card-w-service.0502423f.png";